'use client';

import { Button } from '@shared/components/shadcn';
import dynamic from 'next/dynamic';
import { type ComponentProps, useState } from 'react';

// Loaded on first open only: keeps GameLauncher and vaul out of the thank-you page bundle.
const ScratchcardGameLauncherModal = dynamic(() => import('./ScratchcardGameLauncherModal').then(module => module.ScratchcardGameLauncherModal), { ssr: false });

type ScratchcardPlayButtonProps = { scratchcardName: string } & Omit<ComponentProps<typeof Button>, 'onClick' | 'asChild'>;

/**
 * Play button that opens the scratchcard game launcher for the given scratchcard name (title, mapping path or game code).
 * Reusable from any page: only the scratchcard name is needed.
 */
function ScratchcardPlayButton({ scratchcardName, ...buttonProps }: ScratchcardPlayButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  const handleClick = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleClick} />
      {hasOpened && <ScratchcardGameLauncherModal scratchcardName={scratchcardName} open={isOpen} onOpenChange={setIsOpen} />}
    </>
  );
}

export { ScratchcardPlayButton, type ScratchcardPlayButtonProps };
